
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[quoteId]",
      function () {
        return require("private-next-pages/[quoteId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[quoteId]"])
      });
    }
  